/**
* In this file contains the Medical Issues Vitals Details popup
**/
import { Modal } from 'react-bootstrap';
import { getVitalsName,getVitalsUnit } from './../../services/UtilsService';
import { useTranslation } from 'react-i18next';

function VitalsModal(props) {
	
	//To callback function for close camera modal
	const closeModal = () => {
		props.handleClose();
	}
	const role = Number(localStorage.getItem('role'));
	const { t } = useTranslation();
	return (
	<Modal 
		show={props.data.showVitals}
		onHide={closeModal}
		backdrop="static"
		keyboard={false}
		size="md"
		aria-labelledby="contained-modal-title-vcenter"
		centered
	>
		<Modal.Header closeButton className={`${role===4?'admin-modal-header':''}`}>
			<Modal.Title>{t('modal.VitalsDetail')}</Modal.Title>
		</Modal.Header>
		<Modal.Body>
		<div className="row">
			<div className="col-xxl-12 mb-5">
				<div className="table-responsive">	
					{/*Table*/}
					<table className="table table-borderless theme-table">
						<thead>
						  <tr>
							<th>{t('sidebar.vitals')}</th>
							<th>{t('common.reading')}</th>
							<th>{t('common.deviceName')}</th>
						  </tr>
						</thead>
						<tbody>
						{props.data.vitalsValue && props.data.vitalsValue.length !==0 && props.data.vitalsValue.map((item,i)=>(
						<tr key={i}>
								<td>{getVitalsName(item.category, t)}</td>	
								<td>{getVitalsUnit(item.category,item.value)}</td>	
								<td>{item.device_name ? item.device_name : '--' }</td>
						</tr>))}
						{props.data.vitalsValue.length ===0 &&<tr>
							<td colSpan="3" className="text-center">{t('common.noRecord')}</td>
						</tr>}
						</tbody>
					</table>
				</div>
				{/*End Table*/}
			</div>
		</div>
	    </Modal.Body>
	{/*Footer*/}
	<Modal.Footer>
		<button type="button" className={`btn btn-sm ${role===4?'btn-tmAquaGreen':'btn-tmPink'}`} onClick={closeModal} data-bs-dismiss="modal">{t('modal.close')}</button>
	</Modal.Footer>
	{/*End Footer*/}
	</Modal>
	);
}

export default VitalsModal;
